import moment from "moment";

const toNextIsoWeekday = (date, isoWeekday) => {
  const m = moment(date);
  const currentIsoWeekday = m.isoWeekday();

  if (currentIsoWeekday >= isoWeekday) m.add(1, "week");

  return m.isoWeekday(isoWeekday).toDate();
};

export default toNextIsoWeekday;



// WEBPACK FOOTER //
// ./src/helpers/toNextIsoWeekday.js